import {
  IonButtons,
  IonHeader,
  IonIcon,
  IonMenuButton,
  IonRippleEffect,
  IonRouterLink,
  IonTitle,
  IonToolbar,
  useIonRouter
} from '@ionic/react'
import React, { useEffect, useMemo, useState } from 'react'

import { menuController } from '@ionic/core'

import { chevronBack } from 'ionicons/icons'
import { useMediaQuery } from 'react-responsive'
import styled from 'styled-components'
import { convertPeriodToDisplayString, useSafeAreaInset } from '../../../libs/utils'
import { useGetTermList } from '../../../modules/term'
import { SP_MAX_WIDTH } from '../../../setting'
import { Box, SelectBox } from '../../atoms'

type Size = number | string
export interface HeaderProps {
  width?: Size
  height?: number
  zIndex?: number
  title?: string
  termId?: string
  disableTermSelectBox?: boolean
  back?: boolean
}

const StyledToolBar = styled(IonToolbar)`
  --background: #ffffff;
  background: #ffffff;
  box-shadow: none;
  border-bottom: 1px solid #e8e8e8;
`

const StyledIonTitle = styled(IonTitle)`
  --padding-start: 0;
  --padding-end: 0;
`

const StyledHeader = styled(IonHeader)`
  .header-md::after {
    background-image: none;
  }
`

export const Header = ({
  width = '100%',
  height = 64,
  zIndex = 999,
  title = 'CONNECT VIEW',
  disableTermSelectBox = false,
  termId,
  back = false
}: HeaderProps) => {
  const [value, setValue] = useState<string | undefined>(termId)
  const router = useIonRouter()
  const { terms = [] } = useGetTermList()
  const { value: topInset } = useSafeAreaInset('top')
  const options = useMemo(
    () => terms.map(item => ({ label: convertPeriodToDisplayString(item.period, item.displayName), value: item.id })),
    [terms]
  )

  const [mountMenu, setMenu] = useState(false)

  const isSp = useMediaQuery({
    query: `(max-device-width: ${SP_MAX_WIDTH})`
  })

  const handleSelected = (value: string) => {
    setValue(value)
    router.push(`/search?termId=${value}`, 'forward', undefined, { unmount: true })
  }

  useEffect(() => {
    setValue(termId)
  }, [termId])

  const canBack = useMemo(() => {
    return router.canGoBack() && back && isSp
  }, [router, back, isSp])

  useEffect(() => {
    const checkEnable = async () => {
      const enable = await menuController.isEnabled('main-content')
      if (!enable) {
        setTimeout(() => {
          checkEnable()
        }, 128)
        return
      }
      setMenu(true)
    }
    checkEnable()
  }, [])

  return (
    <>
      <StyledHeader mode="md" style={{ width, height: `${height + topInset}px`, zIndex }}>
        <StyledToolBar style={{ height: `${height + topInset}px`, backgroundColor: 'white', position: 'relative' }}>
          {canBack && (
            <Box
              color="#303030"
              width="50px"
              height="50px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              className="ion-activatable"
              overflow="hidden"
              position="relative"
              onClick={() => router.goBack()}
            >
              <IonIcon icon={chevronBack} style={{ fontSize: '18px', color: '#303030' }} />
              <IonRippleEffect />
            </Box>
          )}

          {mountMenu && !isSp && (
            <IonButtons slot="end" style={{ height: `${height + topInset}px` }}>
              <IonMenuButton
                color="dark"
                menu="main-content"
                autoHide={false}
                onClick={async () => {
                  await menuController.isEnabled()
                  menuController.open('main-content')
                }}
              />
            </IonButtons>
          )}

          {!canBack && (
            <StyledIonTitle size="large" style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0 }}>
              <IonRouterLink routerLink={'/'} routerOptions={{ unmount: true }}>
                <div
                  style={{
                    width: '100%',
                    height: `${height + topInset}px`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: isSp ? 'flex-start' : 'center',
                    paddingLeft: isSp ? '16px' : '0',
                    paddingTop: `${topInset}px`
                  }}
                >
                  <img
                    src="/assets/logo-black.png"
                    alt="CONNECT VIEW"
                    style={{ height: '40px', width: 'auto', objectFit: 'contain' }}
                  />
                </div>
              </IonRouterLink>
            </StyledIonTitle>
          )}
          {!disableTermSelectBox && (
            <Box
              position="absolute"
              top="0"
              right={isSp ? '16px' : '48px'}
              height="100%"
              display="flex"
              alignItems="center"
            >
              <SelectBox placeholder="動画一覧から選ぶ" options={options} value={value} onSelected={handleSelected} />
            </Box>
          )}
        </StyledToolBar>
      </StyledHeader>
    </>
  )
}
